import styled from "styled-components";
import { Dimen } from "../../constants/legacy";

export default styled("section")`
  padding: 6rem 0;
  @media (max-width: ${Dimen.breakpointDefault}px) {
    padding: 3rem 0;
  }
`;
